import { ValidatorFn, FormGroup } from '@angular/forms';

export function formChanged(initialValue: any): ValidatorFn {
  return (control: FormGroup): {[key: string]: any} => {
    const changed = (JSON.stringify(initialValue) !== JSON.stringify(control.getRawValue()));
    return (changed) ? null : { changed: true };
  };
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/validators/form-changed.validator.ts